import { createStorageAtomFactory } from '@exodus/atoms'

const createShownAnnoucementsAtom = ({ storage }) =>
  createStorageAtomFactory({ storage })({
    key: 'shown',
    defaultValue: {},
    isSoleWriter: true,
  })

export default createShownAnnoucementsAtom
